export const MEDIA_FOLDER_KINDS = Object.freeze({
  REGULAR: 'regular',
  TYPE: 'type',
  ACTIVITY: 'activity',
  GENERAL: 'general',
})

export const MEDIA_ACTIVITY_TYPES = Object.freeze({
  VACANCY: 'vacancy',
  ONE_DAY_VACANCY: 'one_day_vacancy',
  GROUP_PROJECT: 'group_project',
  ORGANISATION_GROUP_PROJECT: 'organisation_group_project',
  CALENDAR_ITEM: 'calendar_item',
  IMPACT_DAY: 'impact_day',
  BLOG_POST: 'blog_post',
  PAGE: 'page',
})

// The activity type of an experience page made of a folder under the general folder, which has no activity of its own:
// the page is keyed on the folder itself
export const EXPERIENCE_PAGE_FOLDER_TYPE = 'folder'

// The kinds of page whose date, organisation and location an admin enters by hand, as nothing they are made of carries
// a day, an organiser or a place of its own
export const EXPERIENCE_PAGE_CUSTOM_DATE_TYPES = Object.freeze([MEDIA_ACTIVITY_TYPES.VACANCY, MEDIA_ACTIVITY_TYPES.BLOG_POST,
  MEDIA_ACTIVITY_TYPES.PAGE, EXPERIENCE_PAGE_FOLDER_TYPE])

/**
 * A folder the platform manages rather than an admin: it is never renamed, moved or deleted by hand, and the name it
 * stores is a translation key rather than something someone typed. Both the gallery and the routes read it here, so
 * they agree on which folders are out of bounds.
 */
export const MANAGED_MEDIA_FOLDER_KINDS = Object.freeze([MEDIA_FOLDER_KINDS.TYPE, MEDIA_FOLDER_KINDS.GENERAL])
